import { Icon } from '@material-ui/core';
import SyncAlt from '@material-ui/icons/SyncAlt';
import FaCircleBoxesIcon from 'app/assets/icon/FACircleBoxesIcon';
import FaCircleCalcIcon from 'app/assets/icon/FACircleCalcIcon';
import FaCircleStoreIcon from 'app/assets/icon/FACircleStoreIcon';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import { AUTHORITIES } from 'app/services/authService/authService';
import i18next from 'i18next';
import React from 'react';
import {
  FaArrowCircleDown,
  FaArrowCircleUp,
  FaBoxes,
  FaCalendarCheck,
  FaChartPie,
  FaCreditCard,
  FaFile,
  FaFileContract,
  FaLock,
  FaMoneyCheck,
  FaRulerHorizontal,
  FaShippingFast,
  FaShoppingBag,
  FaShoppingCart,
  FaTag,
  FaTools,
  FaTruck,
  FaUserTag,
  FaUsers,
} from 'react-icons/fa';
import en from './navigation-i18n/en';
import ptBr from './navigation-i18n/pt-br';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('pt-br', 'navigation', ptBr);

const navigationConfig = [
  {
    id: 'vendas_servicos',
    title: 'Vendas e serviços',
    type: 'group',
    icon: FaCircleStoreIcon,
    translate: 'Vendas e serviços',
    gestao: [
      {
        id: 'vendas',
        title: 'Vendas',
        type: 'item',
        exact: true,
        url: '/vendas-servicos/venda',
        icon: FaTag,
        translate: 'Vendas',
        authority: AUTHORITIES.VENDA_VISUALIZAR,
      },
      {
        id: 'contratos',
        title: 'Contratos',
        type: 'item',
        exact: true,
        url: '/vendas-servicos/contrato',
        icon: FaFileContract,
        translate: 'Contratos',
        authority: AUTHORITIES.CONTRATO_VISUALIZAR,
      },
      {
        id: 'ordem_servico',
        title: 'Ordem de serviço',
        type: 'item',
        exact: true,
        url: '/vendas-servicos/ordem-servico',
        icon: FaTools,
        translate: 'Ordem de serviço',
        authority: AUTHORITIES.ORDEMSERVICO_VISUALIZAR,
      },
    ],
    cadastro: [
      {
        id: 'clientes',
        title: 'Clientes',
        type: 'item',
        exact: true,
        url: '/vendas-servicos/cliente',
        icon: FaUsers,
        translate: 'Clientes',
        authority: AUTHORITIES.CLIENTE_VISUALIZAR,
      },
      {
        id: 'servico',
        title: 'Serviços',
        type: 'item',
        exact: true,
        url: '/vendas-servicos/servico',
        icon: ServicoIcon,
        translate: 'Serviços',
        authority: AUTHORITIES.SERVICO_VISUALIZAR,
      },
      {
        id: 'vendedores',
        title: 'Vendedores',
        type: 'item',
        exact: true,
        // url: '/vendas-servicos/vendedores',
        url: '/configuracao?vendedores=true',
        icon: FaUserTag,
        translate: 'Vendedores',
        authority: AUTHORITIES.VENDEDOR_VISUALIZAR,
      },
    ],
  },
  {
    id: 'suprimentos',
    title: 'Suprimentos',
    type: 'group',
    icon: FaCircleBoxesIcon,
    translate: 'Suprimentos',
    gestao: [
      {
        id: 'compras',
        title: 'Compras',
        type: 'item',
        exact: true,
        url: '/suprimentos/compra',
        icon: FaShoppingBag,
        translate: 'Compras',
        authority: AUTHORITIES.COMPRA_VISUALIZAR,
      },
      {
        id: 'estoque',
        title: 'Estoque/Inventário',
        type: 'item',
        exact: true,
        url: '/suprimentos/estoque',
        icon: FaBoxes,
        translate: 'Estoque/Inventário',
        authority: AUTHORITIES.ESTOQUE_VISUALIZAR,
      },
    ],
    cadastro: [
      {
        id: 'fornecedores',
        title: 'Fornecedores',
        type: 'item',
        exact: true,
        url: '/suprimentos/fornecedor',
        icon: FaTruck,
        translate: 'Fornecedores',
        authority: AUTHORITIES.FORNECEDOR_VISUALIZAR,
      },
      {
        id: 'produto',
        title: 'Produtos',
        type: 'item',
        exact: true,
        url: '/suprimentos/produto',
        icon: FaShoppingCart,
        translate: 'Produtos',
        authority: AUTHORITIES.PRODUTO_VISUALIZAR,
      },
      {
        id: 'transportadora',
        title: 'Transportadoras',
        type: 'item',
        exact: true,
        url: '/suprimentos/transportadora',
        icon: FaShippingFast,
        translate: 'Transportadoras',
        authority: AUTHORITIES.TRANSPORTADORA_VISUALIZAR,
      },
    ],
  },
  {
    id: 'financeiro',
    title: 'Financeiro',
    type: 'group',
    icon: FaCircleCalcIcon,
    translate: 'Financeiro',
    gestao: [
      {
        id: 'faturamento',
        title: 'Faturamento',
        type: 'item',
        exact: true,
        url: '/financeiro/faturamento',
        icon: FaMoneyCheck,
        translate: 'Faturamento',
        authority: AUTHORITIES.CONTARECEBER_VISUALIZAR,
      },
      {
        id: 'conta_receber',
        title: 'Contas a receber',
        type: 'item',
        exact: true,
        url: '/financeiro/conta-receber',
        icon: FaArrowCircleUp,
        translate: 'Contas a receber',
        authority: AUTHORITIES.CONTARECEBER_VISUALIZAR,
      },
      {
        id: 'conta_pagar',
        title: 'Contas a pagar',
        type: 'item',
        exact: true,
        url: '/financeiro/conta-pagar',
        icon: FaArrowCircleDown,
        translate: 'Contas a pagar',
        authority: AUTHORITIES.CONTAPAGAR_VISUALIZAR,
      },
      {
        id: 'conciliacao',
        title: 'Conciliação',
        type: 'item',
        // exact: true,
        url: '/conciliacao',
        icon: () => (
          <SyncAlt
            style={{
              width: 14,
              height: 14,
              fontSize: 16,
            }}
          />
        ),
        translate: 'Conciliação',
        authority: AUTHORITIES.CONCILIACAO_VISUALIZAR,
      },
      {
        id: 'notas_fiscais',
        title: 'Notas fiscais',
        type: 'item',
        exact: true,
        url: '/financeiro/nota-fiscal',
        icon: FaFile,
        translate: 'Notas fiscais',
        authority: AUTHORITIES.NOTAS_FISCAIS_VISUALIZAR,
      },
      {
        id: 'transferencia',
        title: 'Transferências',
        type: 'item',
        // exact: true,
        url: '/transferencia',
        icon: () => (
          <Icon
            style={{
              width: 14,
              height: 14,
              fontSize: 16,
            }}
          >
            compare_arrows
          </Icon>
        ),
        translate: 'Transferências',
        authority: AUTHORITIES.TRANSFERENCIA_VISUALIZAR,
      },
      {
        id: 'fechamento_periodo',
        title: 'Fechamento do período',
        type: 'item',
        exact: true,
        url: window.location,
        icon: FaLock,
        translate: 'Fechamento do período',
        authority: AUTHORITIES.PERIODOFECHADO_VISUALIZAR,
        financeiro: 'fechamentoPeriodo',
      },
      {
        id: 'acompanhar_regua_cobranca',
        title: 'Régua de cobrança',
        type: 'item',
        exact: true,
        url: '/financeiro/acompanhar_regua_cobranca',
        icon: FaRulerHorizontal,
        translate: 'Régua de cobrança',
        authority: AUTHORITIES.ACOMPANHAR_RC_VISUALIZAR,
      },
    ],
    cadastro: [
      {
        id: 'imposto',
        title: 'Impostos de despesas',
        type: 'item',
        // exact: true,
        url: '/financeiro/imposto',
        icon: FaCalendarCheck,
        translate: 'Impostos de despesas',
        authority: AUTHORITIES.IMPOSTO_VISUALIZAR,
      },
      {
        id: 'contas',
        title: 'Contas',
        type: 'item',
        exact: true,
        url: '/configuracao?contas=true',
        icon: FaCreditCard,
        translate: 'Contas',
        authority: AUTHORITIES.CONTA_VISUALIZAR,
      },
    ],
  },
  {
    id: 'relatorios',
    title: 'Relatórios',
    type: 'group',
    icon: FaChartPie,
    translate: 'Relatórios',
    url: '/relatorios',
    authority: [
      AUTHORITIES.RELATORIO_DRE_VISUALIZAR,
      AUTHORITIES.RELATORIO_RECEITA_VISUALIZAR,
      AUTHORITIES.RELATORIO_DESPESA_VISUALIZAR,
      AUTHORITIES.RELATORIO_FLUXOCAIXA_VISUALIZAR,
      AUTHORITIES.RELATORIO_BALANCETE_VISUALIZAR,
      AUTHORITIES.REL_VENDA_VISUALIZAR,
      AUTHORITIES.RELATORIO_CC_VISUALIZAR,
      AUTHORITIES.REL_CLIENTE_VISUALIZAR,
      AUTHORITIES.REL_CONTRATO_VISUALIZAR,
      AUTHORITIES.REL_RECEITA_CLIENTE_VISUALIZAR,
      AUTHORITIES.REL_DESPESA_FORNECEDOR_VISUALIZAR,
      AUTHORITIES.REL_CERTIDAO_NEGATIVA_VISUALIZAR,
    ],
  },
  {
    id: 'configuracoes',
    title: 'Configurações',
    type: 'group',
    icon: 'settings',
    url: '/configuracao',
    authority: [
      AUTHORITIES.PARAMETRO_VISUALIZAR,
      AUTHORITIES.CONTA_VISUALIZAR,
      AUTHORITIES.USUARIO_VISUALIZAR,
      AUTHORITIES.GRUPOACESSO_VISUALIZAR,
      AUTHORITIES.CATEGORIA_VISUALIZAR,
      AUTHORITIES.CENTRO_CUSTO_VISUALIZAR,
      AUTHORITIES.VENDEDOR_VISUALIZAR,
      AUTHORITIES.INTEGRACAO_CONTABIL_VISUALIZAR,
      AUTHORITIES.CONFIGURAR_RC_VISUALIZAR,
    ],
  },
];

export default navigationConfig;
